import { createField } from "./sampling-analysis-info.section";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });

    if (model.id) {
        data.products = {
            fetchCriteria: {
                select: ["**",
                    "refSendSamplingProduct.*",
                    "refSendSamplingProduct.refSampling.id",
                    "refSendSamplingProduct.refSampling.approveCode",
                    "refSendSamplingProduct.refSampling.manufacturer",
                    "refSendSamplingProduct.refSampling.manufactureDate",
                    "refSendSamplingProduct.refSampling.importer",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.id",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.id",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.approveCode",
                ],
                page: 0,
                size: 1000000,
                where: [{ name: "refSamplingAnalysis.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children: [
                    {
                        name: "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.packages",
                        select: ["id", "refPackage1.id", "refPackage1.value", "refPackage2.id", "refPackage2.value", "refPackage3.id", "refPackage3.value",],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                    }
                ]
            }
        };
    }
};

export const createForm = () => {
    const form = {
        refDepartment: null,
        refAnalysisDepartment: null,
        refUserCompany: null,
        refUser: null,
        approveCode: null,
        effectiveDate: null,
        expireDate: null,
        refSendSampling: null,
        refResult: null,
        remark: null,
        refStatus: null,
        products: [],
        attachments: [],
    };
    return form;
};